module.exports = __webpack_public_path__ + "img/image-home.463a57a5.svg";